module.exports = __webpack_public_path__ + "naghmeh-social-icon--instagram.svg?bf13b8a370ce78414cffb0dceffaba7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--instagram.svg
// module id = 212
// module chunks = 0